<template>
  <div class="propertyoffice">
    <div class="header">
      <div class="title">物业服务</div>
      <div class="border"></div>
    </div>
    <div class="body">
      <div class="left">
        <div class="position">
          <img :src="mobileResidentOffice1" alt="" />
        </div>
      </div>

      <div class="right">
        随时随地在线完成水电费、物业费、停车费等日常费用的缴纳，省时省力又方便。
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import mobileResidentOffice1 from "../../../../assets/product/mobileResidentOffice1.png";

export default {
  setup() {
    return reactive({
      mobileResidentOffice1: mobileResidentOffice1,
    });
  },
};
</script>

<style scoped>
.propertyoffice {
  width: 100%;
  margin: 24px auto 0;
}
.header .title {
  font-size: 16px;
  text-align: center;
  margin-top: 24px;
}
.header .border {
  width: 16px;
  height: 2px;
  background: #248efb;
  margin: 4px auto 0;
}

.body {
  width: 92vw;
  margin: 0 auto;
  margin-top: 16px;
  text-align: center;
}
.body .left .logo img {
  width: 332px;
}
.body .left .position img {
  width: 238px;
}
.body .left .position img:nth-of-type(1) {
  left: 100%;
}
.body .left .position img:nth-of-type(2) {
  left: 125%;
  bottom: 0;
}
.body .left .position img:nth-of-type(3) {
  left: 150%;
  bottom: 0;
}
.body .right {
  width: 92vw;
  margin: 22px auto 0;
  font-size: 12px;
  color: #3d3d3d;
}
</style>
